import {Component, Input} from '@angular/core';
import {IonCard, IonCardContent, IonIcon} from "@ionic/angular/standalone";
import {Article} from "@interfaces/article";
import {RouterLink} from "@angular/router";
import {DatePipe} from "@angular/common";
import {addIcons} from "ionicons";
import {calendar, eye, image} from "ionicons/icons";

@Component({
  selector: 'app-article-card',
  templateUrl: './article-card.component.html',
  styleUrls: ['./article-card.component.scss'],
  imports: [IonCard, IonCardContent, RouterLink, DatePipe, IonIcon]
})
export class ArticleCardComponent {

  @Input() entry: Article;

  constructor() {
    addIcons({calendar, image, eye});
  }
}
